import HttpV2 from './HttpV2';

class FeatureServiceV2 {
  static async getClientFeatures(id) {
    return HttpV2.get(`features/client/${id}`);
  }

  static async getFeatures() {
    return HttpV2.get(`features`);
  }

  static async toggleFeature(id, clientId, action) {
    const normalizedPayload = {
      _method: 'PATCH'
    }
    return HttpV2.post(`features/${id}/client/${clientId}/${action}`, normalizedPayload);
  }
}

export default FeatureServiceV2;
